export function buildAgencyMcpPrompt(template, modelIds = [], lang = 'en') {
  const ids = [...new Set(modelIds.filter((id) => Number.isSafeInteger(id) && id > 0))].sort((a, b) => a - b)
  const target = ids.length ? ids.map((id) => `#${id}`).join(', ')
    : lang === 'ru' ? 'сначала покажи доступные модели и спроси, с какой начать'
      : 'first list accessible models and ask which one to configure'
  return String(template || '').replace('{{model_ids}}', target)
}
